import * as actionTypes from './actionTypes'

export function updateActorFeild(actor, field, payload) {
  return {
    type: actionTypes.UPDATE_ACTOR_FIELD,
    payload,
    field,
    actor
  }
}

export function updateActorAddress(actor, field, payload) {
  return {
    type: actionTypes.UPDATE_ACTOR_ADDRESS,
    payload,
    actor,
    field
  }
}

export function updateHeaderPartyFeild(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_HEADER_PARTY_FIELD,
    payload,
    field,
    headerPartyIndex
  }
}

export function updateHeaderParty(headerPartyIndex, sameAs) {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_HEADER_PARTY,
      headerPartyIndex,
      sameAs
    })
    dispatch(saveHeaderParties(headerPartyIndex))
  }
}

export function addHeaderParty() {
  return {
    type: actionTypes.ADD_HEADER_PARTY
  }
}

export function addManufacturer(newManufacturer) {
  return {
    type: actionTypes.ADD_MANUFACTURER,
    newManufacturer
  }
}


export function removeHeaderParty(index) {
  return {
    type: actionTypes.REMOVE_HEADER_PARTY,
    payload: index
  }
}

export function updateHeaderPartyAddress(headerPartyIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_HEADER_PARTY_ADDRESS,
    payload,
    headerPartyIndex,
    field
  }
}

export function updateField(field, payload) {
  return {
    type: actionTypes.UPDATE_FIELD,
    payload,
    field
  }
}

export function updateConsigneeFeild(field, payload) {
  return {
    type: actionTypes.UPDATE_IMPORTER_FIELD,
    payload,
    field
  }
}

export function saveActorName(actor) {
  return {
    type: actionTypes.SAVE_ACTOR_NAME,
    actor
  }
}

export function saveActorAddress(actor) {
  return {
    type: actionTypes.SAVE_ACTOR_ADDRESS,
    actor
  }
}

export function saveHeaderParties(index) {
  return {
    type: actionTypes.SAVE_HEADER_PARTIES,
    index
  }
}

export function saveImporter() {
  return {
    type: actionTypes.SAVE_IMPORTER
  }
}

export function saveImporterName() {
  return {
    type: actionTypes.SAVE_IMPORTER_NAME
  }
}

export function saveImporterNo(){
  return {
    type: actionTypes.SAVE_IMPORTER_NUMBER
  }
  
}

export function saveConsigneeName() {
  return {
    type: actionTypes.SAVE_CONSIGNEE_NAME
  }
}

export function saveConsigneeNo(){
  return {
    type: actionTypes.SAVE_CONSIGNEE_NUMBER
  }
  
}
export function saveConsignee() {
  return {
    type: actionTypes.SAVE_CONSIGNEE
  }
}

